import * as accessibilityStatementApi from '../services/api/accessibility_statement';

export const ACCESSIBILITY_STATEMENT_RECEIVED = 'ACCESSIBILITY_STATEMENT_RECEIVED';

export function refreshAccessibilityStatement(serviceId) {

    return dispatch => {

        accessibilityStatementApi
            .getOne(serviceId)
            .then(res => dispatch(accessibilityStatementRefreshed(res.payload)));
    }
}

export function accessibilityStatementRefreshed(accessibilityStatement) {
    return {
        type: ACCESSIBILITY_STATEMENT_RECEIVED,
        accessibilityStatement
    }
}